import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function for conditionally joining classNames together with Tailwind CSS support
 * Combines clsx for conditional classes and tailwind-merge for conflicting Tailwind classes
 * 
 * @param {...(string|Object|Array|undefined|null|boolean)} inputs - Class names to combine
 * @returns {string} Combined and merged class names
 * 
 * @example
 * cn('base-class', 'another-class') // 'base-class another-class'
 * cn('base', { 'active': isActive, 'disabled': isDisabled }) // 'base active' (if isActive is true)
 * cn('px-4 px-2', 'py-2') // 'px-2 py-2' (last px- wins)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Default export
export default cn;